import { type ModuleData, ModuleProvider, useModule } from '#providers'

interface AssetReplacementConfig {
	clientInputsType: string | undefined
}

interface AssetReplacementData {}

export type AssetReplacementModuleData = ModuleData<
	AssetReplacementData,
	void,
	AssetReplacementConfig
>

export const AssetReplacementModuleProvider: typeof ModuleProvider<AssetReplacementModuleData> =
	ModuleProvider

export const useAssetReplacementModule: typeof useModule<AssetReplacementModuleData> =
	useModule
